import { useSelector } from 'react-redux';
import styled from 'styled-components';

function ActivitiesNavigationHeader() {
  const { account } = useSelector((state) => state.internalReducer.internal);
  const { trialName } = account || {};

  return (
    <HeaderBox>
      <NavLink href="/">{trialName}</NavLink>
      <Divider>/</Divider>
      <CurrentPageWrapper>Activity Log</CurrentPageWrapper>
    </HeaderBox>
  );
}

const HeaderBox = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #c8c8c8;
  gap: 8px;
`;
const Divider = styled.span``;
const NavLink = styled.a``;
const CurrentPageWrapper = styled.span`
  font-weight: 700;
`;

export default ActivitiesNavigationHeader;
